import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as coachAPI from '../../lib/api/coach';
import { sort, sortReverse } from '../../lib/commonFunc/commonFunc';

const [
  LOAD_COACH,
  LOAD_COACH_SUCCESS,
  LOAD_COACH_FAILURE,
] = createRequestActionTypes('coach/LOAD_COACH');

const [
  CHAMGE_COACH_TYPE,
  CHAMGE_COACH_TYPE_SUCCESS,
  CHAMGE_COACH_TYPE_FAILURE,
] = createRequestActionTypes('coach/CHAMGE_COACH_TYPE');

const [
  DELETE_COACH,
  DELETE_COACH_SUCCESS,
  DELETE_COACH_FAILURE,
] = createRequestActionTypes('coach/DELETE_COACH');

const [
  MODIFY_COACH_NOTIFICATION,
  MODIFY_COACH_NOTIFICATION_SUCCESS,
  MODIFY_COACH_NOTIFICATION_FAILURE,
] = createRequestActionTypes('coach/MODIFY_COACH_NOTIFICATION');

const [
  MODIFY_COACH_MENU,
  MODIFY_COACH_MENU_SUCCESS,
  MODIFY_COACH_MENU_FAILURE,
] = createRequestActionTypes('coach/MODIFY_COACH_MENU');

const [
  LOAD_MY_MENU,
  LOAD_MY_MENU_SUCCESS,
  LOAD_MY_MENU_FAILURE,
] = createRequestActionTypes('coach/LOAD_MY_MENU');

const INIT_RES = createRequestActionTypes('coach/INIT_RES');

export const changeCoachType = createAction(
  CHAMGE_COACH_TYPE,
  ({ clubID, targetID, memberType, socketKey }) => ({
    clubID,
    targetID,
    memberType,
    socketKey,
  }),
);

export const loadCoach = createAction(
  LOAD_COACH,
  ({ clubID, playerID, socketKey }) => ({
    clubID,
    playerID,
    socketKey,
  }),
);

export const deleteCoach = createAction(
  DELETE_COACH,
  ({ clubID, targetID, socketKey }) => ({
    clubID,
    targetID,
    socketKey,
  }),
);

export const modifyCoachNotificationSetting = createAction(
  MODIFY_COACH_NOTIFICATION,
  ({ clubID, playerID, groupReservation, sales, socketKey }) => ({
    clubID,
    playerID,
    groupReservation,
    sales,
    socketKey,
  }),
);

export const modifyCoachMenuSetting = createAction(
  MODIFY_COACH_MENU,
  ({ clubID, playerID, webMenuHidden, socketKey }) => ({
    clubID,
    playerID,
    webMenuHidden,
    socketKey,
  }),
);

export const loadMyMenu = createAction(
  LOAD_MY_MENU,
  ({ clubID, playerID, socketKey }) => ({
    clubID,
    playerID,
    socketKey,
  }),
);

export const initCoachRes = createAction(INIT_RES)

const loadCoachSaga = createRequestSaga(LOAD_COACH, coachAPI.loadCoach);
const changeCoachTypeSaga = createRequestSaga(CHAMGE_COACH_TYPE, coachAPI.changeCoachType);
const deleteCoachSaga = createRequestSaga(DELETE_COACH, coachAPI.remove);
const modifyCoachNotificationSaga = createRequestSaga(MODIFY_COACH_NOTIFICATION, coachAPI.modifyCoachNotificationSetting);
const modifyCoachMenuSaga = createRequestSaga(MODIFY_COACH_MENU, coachAPI.modifyCoachMenuSetting);
const loadMyMenuSaga = createRequestSaga(LOAD_MY_MENU, coachAPI.loadCoachMenu);

export function* coachSaga() {
  yield takeLatest(LOAD_COACH, loadCoachSaga);
  yield takeLatest(CHAMGE_COACH_TYPE, changeCoachTypeSaga);
  yield takeLatest(DELETE_COACH, deleteCoachSaga);
  yield takeLatest(MODIFY_COACH_NOTIFICATION, modifyCoachNotificationSaga);
  yield takeLatest(MODIFY_COACH_MENU, modifyCoachMenuSaga);
  yield takeLatest(LOAD_MY_MENU, loadMyMenuSaga);
}

const initialState = {
  clubID: null,
  playerID: null,
  coaches: null,
  error: null,
  deleteRes: null,
  changeTypeRes: null,
  notificationRes: null,
  menuRes: null,
  myMenuHidden: [],
  myMenuLoaded: false,
};

const coach = handleActions(
  {
    [INIT_RES]: (state) => ({
      ...state,
      deleteRes: null,
      changeTypeRes: null,
      notificationRes: null,
      menuRes: null,
    }),
    [MODIFY_COACH_NOTIFICATION_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      notificationRes: res.result,
    }),
    [MODIFY_COACH_NOTIFICATION_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [MODIFY_COACH_MENU_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      menuRes: res.result,
    }),
    [MODIFY_COACH_MENU_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
      menuRes: -1,
    }),
    [LOAD_MY_MENU_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      myMenuHidden:
        data && data.webMenuHidden
          ? String(data.webMenuHidden).split('%&').filter(Boolean)
          : [],
      myMenuLoaded: true,
    }),
    [LOAD_MY_MENU_FAILURE]: (state) => ({
      ...state,
      // fail-open: 본인 메뉴설정 로드 실패해도 강사를 잠그지 않고 전체 노출
      myMenuHidden: [],
      myMenuLoaded: true,
    }),
    [CHAMGE_COACH_TYPE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      changeTypeRes: res.result,
    }),
    [CHAMGE_COACH_TYPE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LOAD_COACH_SUCCESS]: (state, { payload: coaches }) => ({
      ...state,
      coaches: {infos: sortReverse(coaches.infos, "name")},
    }),
    [LOAD_COACH_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [DELETE_COACH_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      deleteRes: res.result
    }),
    [DELETE_COACH_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
  },
  initialState,
);

export default coach;
